import { Heart, ShoppingCart } from "lucide-react";
import React, { useState, useEffect, useContext } from "react";
import "./ProductCard.css"; // Import the CSS file
import { LanguageContext } from "../../context/LanguageContext";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const { t } = useContext(LanguageContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/product/${product.id}`);
  };

  const storedWishlist = localStorage.getItem("wishlist");

  const handleOnclick = () => {
    const user = localStorage.getItem("users");
    if (!user) {
      enqueueSnackbar("Please log in to add products to your cart!", {
        variant: "error",
      });
      return;
    }
    handleCardClick();
  };

  const addToWishlist = () => {
    const user = localStorage.getItem("users");
    let wishlist = [];

    if (!user) {
      enqueueSnackbar("Please log in to add products to your wishlist!", {
        variant: "error",
      });
      return;
    }

    if (storedWishlist) {
      wishlist = JSON.parse(storedWishlist);
    }

    const updatedWishlist = [...wishlist, { ...product }];
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
    enqueueSnackbar("Product added to wishlist!", { variant: "success" });
  };

  return (
    <div className="product-card-g">
      <div className="product-image" onClick={handleCardClick}>
        {product.discountPercentage && (
          <span className="discount">-{product.discountPercentage} %</span>
        )}
        <img src={product.imageUrl} alt={product.name} />
      </div>

      <div className="product-info-g">
        <h3>{product.name}</h3>
        <Heart className="wishlist-icon" onClick={addToWishlist} />
        <div className="price-info">
          <span className="current-price">
            $
            {product.originalPrice -
              (
                (product.originalPrice * product.discountPercentage) /
                100
              ).toFixed(2)}
          </span>
          {product.originalPrice && (
            <span className="original-price">${product.originalPrice}</span>
          )}
        </div>
        <button className="add-to-cart" onClick={handleOnclick}>
          <ShoppingCart size={18} /> {t("labels.addToCart")}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
